import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'svc-img',
  templateUrl: './svc-img.component.html',
  styleUrls: ['./svc-img.component.scss']
})
export class SvcImgComponent implements OnChanges {
  @Input() src!: string;
  @Input() height: string;
  @Input() width: string;
  @Input() minHeight: string;
  @Input() minWidth: string;
  @Input() borderWidth: number;
  @Input() customClass: string = '';
  @Input() fitContent: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down' = 'cover';
  @Output() onError = new EventEmitter<void>();

  protected loading = true;

  public ngOnChanges(changes: SimpleChanges): void {
    if ('src' in changes) {
      this.loading = true;
    }
  }

  public emitError(): void {
    this.loading = false;
    this.onError.emit();
  }
}
